






























































































































































































































































import {
  Component,
  Prop,
  Mixins
} from "vue-property-decorator";
import AbpBase from "../../../lib/abpbase";
import columns from "./columnsDetailEdit";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import Entity from "@/store/entities/entity";
import AppConsts from "@/lib/appconst";
import _ from "lodash";
import moment from "moment";
import selectModal from './selectModal.vue'
import selectProductModal from './selectProductModal.vue'
import Util from '@/lib/util'

class Model extends Entity<any>{
    categoryId:number;
    duration:number = null;
    clientCode:string;
    keyword:string;
    type:string;
    name:string;
    note:string;
    EffectiveDate:Date;
    ExpiredDate:Date;
    ApplyDate:Date;
}


@Component({
    components:{selectModal,selectProductModal}
})
export default class Edit extends Mixins(AbpBase,DateTimeMixin) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: Number, default: null }) codeCurrent: any;

  options: any = {
      disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000;
      }
  }
  data: any = [];
  listAll: any = [];
  list: any = [];
  listView: any = [];
  clients: any = [];
  model: Model = new Model();
  categoriesOfClient: [] = [];
  selectModalShow:boolean=false;
  selectModalProductShow:boolean=false;
  pageSize: any = 10;
  currentPage: any = 1;

  get loading(){
    return this.$store.state.warrantyDurationConfig.loading;
  }

  get totalCount(){
      return _.size(this.list);
  }
  
  pageChange(page:number){
    this.currentPage = page;
    this.setView(this.list);
  }

  pagesizeChange(pagesize:number){
    this.pageSize = pagesize;
    this.setView(this.list);
  }

  disabledDates(date) {
    return date && date.valueOf() < Date.now() - 86400000;
  }

  columns = columns;

  onAdd(list) {
    if(_.size(list) > 0){
      var index = 0;
      const newList = this.listAll;
      list.forEach(function(item) {
        if(!_.find(newList, v => v.productId == item.productId && v.product.clientCode == item.product.clientCode)){
          newList.unshift({...item, id: item.productId, isAdd: true  });
        }
      });

      newList.forEach(function(item) {
        item.orderNo = index + 1;
        item.effectiveDate = moment().toDate();
        index++;
      });

      this.listAll = newList;
      this.list = newList
      this.setView(this.list);

    }

    this.selectModalShow = false;
  }

  onAddProduct(list) {
    if(_.size(list) > 0){
      var index = 0;
      const newList = this.listAll;
      list.forEach(function(item) {
        if(!_.find(newList, v => v.productId == item.id && (v.clientCode == item.clientCode || v.product.clientCode == item.clientCode))){
          newList.unshift({...item,productId: item.id, duration: 0, effectiveDate:moment().toDate(), id: item.id, isAdd: true });
        }
      });

      newList.forEach(function(item) {
        item.orderNo = index + 1;
        item.effectiveDate = moment().toDate();
        index++;
      });

      this.listAll = newList;
      this.list = newList
      this.setView(this.list);
    }

    this.selectModalProductShow = false;
  }

  onFilter() {
    const values = this.model;
    let datas = this.listAll;
    if(!_.isEmpty(values.clientCode) && values.clientCode != '_ALL')
      datas = _.filter(datas, v => v.product.clientCode === values.clientCode)
    if(!_.isNil(values.categoryId) && values.categoryId != -1)
      datas = _.filter(datas, v => v.product.categoryId === values.categoryId)
    if(!_.isEmpty(values.keyword))
      datas = _.filter(datas, v => _.toUpper(v.product.sku).includes(_.toUpper(values.keyword) || _.toUpper(v.product.name).includes(_.toUpper(values.keyword))))  
    
    var index = 0;
    datas.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });
    this.list = datas;
    this.setView(this.list);
  }
  
  setView(result) {
    const start = this.currentPage * this.pageSize - this.pageSize;
    const end = start + this.pageSize - 1;
    this.listView = _.filter(result,(item, index) => index >= start && index <= end);
  }

  onApplyAllDay(){
    const { ApplyDate } = this.model;
    this.listAll.forEach(function(item) {
      if(!item.disabled)
        item.effectiveDate = ApplyDate;
    });
  }

  changeApplyDateAll(e){
    this.model.ApplyDate = e;
  }

  changeDurationAll(e){
    this.model.duration = e;
  }

  onApplyTGBH(){
    const { duration } = this.model;
    if(duration < 0) return Util.showNoticeErrorMsg(this, 'Ngày phải lớn hơn 0!');

    this.listAll.forEach(function(item) {
      if(!item.disabled)
        item.duration = duration;
    });
  }

  cancel() {
    this.$emit("input", false);
  }

  onDeleteAll(){
    if(_.find(this.listAll, v=> !v.disabled)){
      this.listAll = [];
      this.list = [];
      this.listView = [];
    }
  }

  onDelete(row){
    const newlist = _.filter(this.listAll, v => v.id != row.id);
    var index = 0;
    newlist.forEach(function(item) {
      item.orderNo = index + 1;
      index++;
    });

    this.listAll = newlist;
    this.list = newlist;
    this.setView(this.list);
  }

  selectModal() {
    this.codeCurrent = null;
    this.selectModalShow = true;
  }

  selectProductModal() {
    this.selectModalProductShow = true;
  }

  save() {
    (this.$refs.queryForm as any).validate(async (valid: boolean) => {
      if (valid) {
        if(_.size(this.listAll) < 1){  
              Util.showNoticeErrorMsg(this, 'Chưa có sản phẩm cấu hình');
            return ;
          }

          const lines = this.listAll;
          lines.forEach(function(item) {
            item.id = item.isAdd ? 0 : item.id;
          }); 

          const data = {
            ...this.model,
            warrantyDurationConfigs: lines
          };
          this.$store
          .dispatch({
            type: `warrantyDurationConfig/${this.codeCurrent > 0 ? 'update' : 'create'}`,
            data: data,
          })
          .then(() => {
            this.$emit("save-success");
            this.$emit("input", false);
            this.model = new Model();
            this.listAll =[];
            this.list =[];
            this.listView =[];  
          });  
      }
    });         
  }

  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
      this.model = new Model();
      this.listAll = [];
      (this.$refs.queryForm as any).resetFields();
      this.list = [];
      this.getpage();
    }
  }

  async getpage(){  
    if(this.codeCurrent > 0){
      await this.$store.dispatch({
          type:'warrantyDurationConfig/get',
          data: {
          id: this.codeCurrent,
        },
      }).then(v => { 
        this.data = v;
        this.currentPage = 1;
        this.pageSize = 10;
        this.model.id = v.id;
        this.model.type = v.type;
        this.model.EffectiveDate = v.effectiveDate;
        this.model.ExpiredDate = v.expiredDate;
        this.model.name = v.name;
        this.model.note = v.note;
        var re = this.data.warrantyDurationConfigs;
        var startIndex = (this.currentPage - 1) * this.pageSize;
        var index = 0;
        re.forEach(function(item) {
          item.effectiveDate = moment(item.effectiveDate).toDate();
          item.orderNo = startIndex + index + 1;
          item.disabled = moment(item.effectiveDate).get('dates') < moment().get('dates')
          index++;
        });
        this.list = re;
        this.listAll = re;
        this.setView(re);
      })
    }
  }

  onchangeDuration(row: any) {
    const index_ = _.findIndex(this.listAll, v => v.id == row.id);
    this.listAll[index_] = row;
  }

  async changeClientCode() {
    await this.getCategoriesOfClientForSelect();
  }

  async getCategoriesOfClientForSelect() {
    await this.$store
      .dispatch({
        type: "category/getCategoriesByClientForSelect",
        data: { clientCode: this.model.clientCode },
      })
      .then(() => {
        var re = this.$store.state.category.categoriesOfClientForSelect;
        re.unshift({ id: -1, name: this.L(AppConsts.All) });
        this.categoriesOfClient = re;
        this.model.categoryId = -1;
      });
  }
  async created(){
    this.getClients();
  }

  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: { hasAllItem: true },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
      });
  }

  rule = {
    name: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Tên cấu hình bắt buộc nhập")),
        trigger: "blur",
      },
    ],
  };
}
